<template>
  <div>
    <pageHeader
      :dropdownData="patientsColumns"
      :props="{ headerName: 'header', value: 'fieldName' }"
      :headerIcon="'users'"
      :headerText="$t('patients')"
      :haveFilterInput="true"
      @filterString="filterStringEventListener"
      @columnName="columnNameEventListener"
      :columnsNumber="[
        'five wide column',
        'two wide column',
        'nine wide column'
      ]"
      @startSearchingProcess="startSearchingProcessEventListener"
    />

    <div style="padding-top: 25px;">
      <abstractTable
        :columns="patientsColumns"
        :useData="false"
        :classes="'ui tablet very compact center aligned celled table'"
        :dataPerPage="25"
        :paginationEnable="true"
        style=""
        :paginationNextButtonText="$t('next')"
        :paginationPervButtonText="$t('previous')"
        :paginationFirstPageButtonText="$t('first')"
        :paginationLastPageButtonText="$t('last')"
        :indexRoute="'patients'"
        :apiObjectName="'patients'"
        :methodFormatter="computedPatients"
        :filters="filterStringBuilder"
        @endSearchingProcess="endSearchingProcessEventListener"
        :startSearchingFlag="startSearching"
      >
        <template slot="table-column">
          <th>{{ $t('actions') }}</th>
        </template>
        <template slot="table-row-after" slot-scope="props">
          <td style="width: 175px">
            <div
              class="ui icon blue very compact mini button"
              style="background-color: #092442"
              :data-tooltip="`${$t('show') + ' ' + $t('log')}`"
              @click="
                navigateTo('Show_Patient', {
                  key: 'params',
                  value: { id: props.row.id }
                })
              "
            >
              {{ $t('show') }}
            </div>
            <div
              class="ui icon blue very compact mini button"
              :data-tooltip="$t('createNewReservation')"
              style="background-color: #092442"
              v-if="isClinicChoosen && ($auth.check('employee') || isAdmin())"
              @click="
                navigateTo('New_Reservation', {
                  key: 'query',
                  value: props.row
                })
              "
            >
              {{ $t('newReservation') }}
            </div>
          </td>
        </template>
      </abstractTable>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data() {
    return {
      filterString: '',
      columnName: 'all',
      startSearching: false,
      isClinicChoosen: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      $('.ui.dropdown').dropdown();
    });

    this.isClinicChoosen = this.getFromLocalStorage('clinicId');

    document.addEventListener('clinicId-changed', () => {
      this.isClinicChoosen = this.getFromLocalStorage('clinicId');
    });
  },
  computed: {
    filterStringBuilder() {
      let listOfFiltersNames = {
        id: 'id',
        code: 'code',
        name: 'patient_name',
        telepone: 'telephone',
        cell_phone: 'cell_phone',
        age: 'date_of_birth',
        weight: 'weight',
        gender: 'gender'
      };

      return (
        '&' + listOfFiltersNames[this.columnName] + '=' + this.filterString
      );
    },
    patientsColumns() {
      return [
        { fieldName: 'id', header: 'Id', show: true, filterable: true },
        { fieldName: 'code', header: 'code', show: true, filterable: true },
        {
          fieldName: 'name',
          header: this.$t('name'),
          show: true,
          filterable: true
        },
        {
          fieldName: 'cell_phone',
          header: this.$t('mobile'),
          show: this.$auth.check('employee') || this.isAdmin(),
          filterable: true
        },
        {
          fieldName: 'age',
          header: this.$t('age'),
          show: true,
          filterable: false
        },
        {
          fieldName: 'telepone',
          header: this.$t('phone'),
          show: this.$auth.check('employee') || this.isAdmin(),
          filterable: false
        },
        {
          fieldName: 'gender',
          header: this.$t('gender'),
          show: true,
          filterable: false
        },
        {
          fieldName: 'weight',
          header: this.$t('weight'),
          show: true,
          filterable: false
        }
      ];
    }
  },
  methods: {
    computedPatients(patients) {
      let formaltedPatients = [];

      window._.each(patients, patient => {
        formaltedPatients.push({
          id: patient.id,
          code: patient.code || '-',
          name: this.adjustName(patient.name),
          telepone: patient.telephone || '-',
          cell_phone: patient.cell_phone,
          age: this.getAge(patient.date_of_birth) || '-',
          weight: patient.weight || '-',
          gender: this.getGender(patient.gender)
        });
      });

      return formaltedPatients;
    },
    filterStringEventListener(event) {
      this.filterString = event.data;
    },
    columnNameEventListener(event) {
      this.columnName = event.data;
    },
    startSearchingProcessEventListener(event) {
      this.startSearching = true;
    },
    endSearchingProcessEventListener(event) {
      this.startSearching = false;
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/patients/Patients.vue